import { IAvailableFilters, IOption } from 'modules/core/types';

import { FILTER_OPTION_VALUES } from './vehicleFilters.const';

export function getEffectiveYearOptions(
  subventionYearOptions: IOption[],
  availableYears: string[] | undefined,
  selectedYearValue: string | undefined,
  yearsMode: string | undefined,
): IOption[] {
  const selectedValue = selectedYearValue ? String(selectedYearValue) : undefined;

  if (!availableYears) {
    return subventionYearOptions;
  }

  const availableYearNumbers = availableYears.map((year) => Number(year)).filter((year) => !Number.isNaN(year));

  if (!availableYearNumbers.length) {
    if (selectedValue) {
      return subventionYearOptions.filter((option) => String(option.value) === selectedValue);
    }

    return [];
  }

  const minAvailableYear = Math.min(...availableYearNumbers);
  const maxAvailableYear = Math.max(...availableYearNumbers);
  const availableYearsSet = new Set(availableYearNumbers.map(String));

  return subventionYearOptions.filter((option) => {
    const optionValueString = String(option.value);
    const optionYear = Number(option.value);

    if (selectedValue && optionValueString === selectedValue) return true;

    // "Filter years" / "Only from" both pick concrete years present in results.
    if (
      yearsMode === FILTER_OPTION_VALUES.YEARS.FILTER_YEARS ||
      yearsMode === FILTER_OPTION_VALUES.YEARS.ONLY_FORM ||
      !yearsMode
    ) {
      return availableYearsSet.has(optionValueString);
    }

    if (yearsMode === FILTER_OPTION_VALUES.YEARS.NEWER_THEN_FROM) {
      return optionYear <= maxAvailableYear;
    }

    if (yearsMode === FILTER_OPTION_VALUES.YEARS.OLDER_THEN_FROM) {
      return optionYear >= minAvailableYear;
    }

    return availableYearsSet.has(optionValueString);
  });
}

/**
 * Whether a facets payload carries any option at all.
 *
 * A search that matched nothing comes back with every facet empty. Taking that literally
 * blanks every dropdown and leaves Reset as the only way out, so callers fall back to the
 * full static option lists instead. Note this is rare once facets are computed exclude-self:
 * each one then still offers whatever is reachable by changing that single field.
 */
export function hasAnyAvailableValues(availableFilters: IAvailableFilters | undefined): boolean {
  if (!availableFilters) return false;

  return Object.values(availableFilters).some((values) => Array.isArray(values) && values.length > 0);
}
